/**
 * Show options
 */
$('.js-select').on('click', '.is-current', function(event) {
	const $this = $(this);
	
	$('.js-select ul').removeClass('is-visible');

	$($this).next().addClass('is-visible');
});

/**
 * Change current option
 */
$('.js-select ul a').on('click', function(event) {
	const $this = $(this);
	
	const text = $this.text();
	const href = $this.attr('href');
	const current = $this.parents('.js-select').find('.is-current');

	current.text(text);
	current.attr('href', href);

	$this.parents('ul').removeClass('is-visible')
});

/**
 * Close options if click outside
 */
$('body').on('click',function(event){
   if(!$(event.target).is('.js-select a')){
     $('.js-select ul').removeClass('is-visible')
   }
});